// extracted by mini-css-extract-plugin
export default {"dataContainer":"Summary_dataContainer__gQ+Rw","headerDataTitle":"Summary_headerDataTitle__v7Cl7","headerDataBody":"Summary_headerDataBody__U7dAV"};